<template>
    <div v-if="policyDetails">
        <div class="row border-bottom mb-2" v-if="isTigaPolicy || isTgaPolicy">
            <div class="col-12">
                <div class="mb-2 float-right">                    
                    <button :disabled="!userHasAccess || deserialisedObject == null" class="btn btn-danger mr-2" @click="handleResetPolicyClick()"><i class="fas fa-ban"></i> Reset policy</button>
                    <button :disabled="deserialisedObject != null" class="btn btn-primary" @click="showModal"><i class="fas fa-file-import"></i> Import policy</button>
                </div>
            </div>
        </div>
        <b-card no-body>
            <b-tabs card>
                <b-tab title="Details">
                    <simple-display-grid key="claimPolicyDetails1"
                                            :columnCount="1"
                                            :inputs="claimPolicyDetailsInputs1"
                                            :values="policyDetails" />

                    <div v-if="deserialisedObject">
                        <collapsible-card class="mt-3" :initCollapsed="true">
                            <h3 slot="title">Policy</h3>
                            <div slot="body">
                                <hr />
                                <simple-display-grid key="claimPolicyDetails7"
                                                        :columnCount="1"
                                                        :inputs="isPolFedPolicy == true ? claimPolicyDetailsInputs8 : claimPolicyDetailsInputs7"
                                                        :values="deserialisedObject" />
                            </div>
                        </collapsible-card>
                        <collapsible-card  v-if="hasPolicyholder" class="mt-3" :initCollapsed="true">
                            <h3 slot="title">Policyholder</h3>
                            <div slot="body">
                                <hr />
                                <simple-display-grid key="claimPolicyDetails2"
                                                        :columnCount="1"
                                                        :inputs="claimPolicyDetailsInputs2"
                                                        :values="deserialisedObject.policyholder" />
                            </div>
                        </collapsible-card>

                        <collapsible-card v-for="(gadget, index) in deserialisedObject.gadgets"
                                            class="mt-3"
                                            :initCollapsed="true">
                            <div slot="title">
                                <h3>Gadget</h3>
                                <p class="text-muted">{{gadget.make + ' / ' + gadget.model}}</p>
                            </div>
                            <div slot="body">
                                <hr />
                                <simple-display-grid :key="'claimPolicyDetails3_' + index"
                                                        :columnCount="1"
                                                        :inputs="claimPolicyDetailsInputs3"
                                                        :values="gadget" />
                            </div>
                        </collapsible-card>

                        <collapsible-card v-for="(traveller, index) in deserialisedObject.additionalTravellers"
                                            class="mt-3"
                                            :initCollapsed="true">
                            <h3 slot="title">Additional traveller {{index + 1}}</h3>
                            <div slot="body">
                                <hr />
                                <simple-display-grid :key="'claimPolicyDetails4_' + index"
                                                        :columnCount="1"
                                                        :inputs="claimPolicyDetailsInputs4"
                                                        :values="traveller" />
                            </div>
                        </collapsible-card>

                        <collapsible-card class="mt-3" :initCollapsed="true">
                            <h3 slot="title">Excess</h3>
                            <div slot="body">
                                <hr />
                                <simple-display-grid key="claimPolicyDetails5"
                                                        :columnCount="1"
                                                        :inputs="claimPolicyDetailsInputs5"
                                                        :values="deserialisedObject" />
                            </div>
                        </collapsible-card>

                        <collapsible-card class="mt-3" :initCollapsed="true">
                            <h3 slot="title">Cover Dates</h3>
                            <div slot="body">
                                <hr />
                                <simple-display-grid key="claimPolicyDetails6"
                                                        :columnCount="1"
                                                        :inputs="claimPolicyDetailsInputs6"
                                                        :values="deserialisedObject" />
                            </div>
                        </collapsible-card>
                    </div>
                    <div v-else>
                        <p>
                            <i class="fas fa-info-circle mr-2"></i>No policy details were available when claim submitted.
                            This may have been because we hadn't received the policy details from our partner at the time OR
                            the customer has entered the incorrect policy number.  Please check CCMS and then import the
                            policy details by clicking the IMPORT POLICY button.
                        </p>

                        <!--<b-modal :id="_uid + 'import-policy-modal'" hide-footer>
                            <template slot="modal-title">
                                Import policy
                            </template>
                            <p>
                                <i class="fas fa-info-circle mr-2"></i>If the customer has entered their policy number incorrectly
                                you can change it to ensure the correct policy details are imported.
                            </p>
                            <div class="d-block text-center">
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">
                                        Policy number
                                    </label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control form-control-sm"
                                               placeholder="Policy number" v-model="importPolicyCriteria.policyNumber">
                                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="policyNumberInValid">
                                            {{policyNumberInValidFeedback}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="float-right">
                                        <button class="btn btn-danger mt-3" @click="handleCancelClick">Cancel</button>
                                        <button class="btn btn-success mt-3 ml-2" @click="handleImportPolicyClick">IMPORT</button>
                                    </div>
                                </div>
                            </div>
                        </b-modal>-->

                        <b-modal :id="_uid + 'import-policy-modal'" hide-footer size="xl">
                            <template slot="modal-title">
                                Import policy
                            </template>
                            <div v-if="tigaPolicyData == null || tigaPolicyData.length == 0">
                                <p>
                                    <i class="fas fa-info-circle mr-2"></i>If the customer has entered their policy number incorrectly
                                    you can change it to ensure the correct policy details are imported.
                                </p>
                                <div class="d-block text-center">
                                    <div class="form-group row">
                                        <label class="col-sm-4 col-form-label">
                                            Policy number
                                        </label>
                                        <div class="col-sm-8">
                                            <input type="text" class="form-control form-control-sm"
                                                   placeholder="Policy number" v-model="importPolicyCriteria.policyNumber">
                                            <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="policyNumberInValid">
                                                {{policyNumberInValidFeedback}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="float-right">
                                            <button class="btn btn-danger mt-3" @click="handleCancelClick">Cancel</button>
                                            <button class="btn btn-primary mt-3 ml-2" @click="handleSearchPolicyClick"><i class="fas fa-search"></i> Search</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="tigaPolicyData != null && tigaPolicyData.length > 0">
                                <p>
                                    <i class="fas fa-info-circle mr-2"></i>Select the policy to import.
                                </p>
                                <div class="row mt-2">
                                    <div class="col">
                                        <data-list :dataCols="tigaPolicyCols"
                                                   :dataListItems="tigaPolicyData"
                                                   :tableClass="'table table-striped table-sm'" 
                                                   @change="handleSelectedItemsChange" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="float-right">
                                            <button class="btn btn-danger mt-3" @click="handleCancelClick">Cancel</button>
                                            <button :disabled="selectedTigaPolicy == null" class="btn btn-success mt-3 ml-2" @click="handleImportPolicyClick"><i class="fas fa-file-import"></i> Import</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-modal>

                    </div>
                </b-tab>
                <b-tab title="JSON">
                    <json-viewer v-model="policyDetails"
                                    :viewMode="0" />
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
    import SimpleDisplayGrid from '@/components/SimpleDisplayGrid.vue'
    import JsonViewer from '@/components/jsonViewer.vue'
    import CollapsibleCard from '@/components/CollapsibleCard.vue'
    import { mapActions, mapGetters } from 'vuex'

    import { required, numeric, minLen } from '@/util/validators'
    import { runValidators, getValidators, getValidatorsIsValid } from '@/util/validation'

    import watchAll from '@/mixins/watchAll.js'
    import validator from '@/mixins/validator.js'

    import { trueFalseToYesNo } from '@/util/formatters'

    import authentication from '@/mixins/authentication.js'
    import userRoles from '@/constants/userRoles.js'

    import DataList from '@/components/DataList.vue'

    let importPolicyCriteriaInit = {
        policyNumber: null,
        validators: [
            {
                item: 'policyNumber',
                validators: [
                    required,
                    minLen(5)
                ],
                isValid: false,
                inValidFeedback: 'Required, MinLength 5'
            }
        ]
    }

    const formatNumber = (dec) => (val) => {
        if (!isNaN(parseFloat(val))) {
            return val.toFixed(dec)
        } else {
            return 0
        }
    }

    export default {
        name: 'PolicyDetails',
        components: {
            'collapsible-card': CollapsibleCard,
            SimpleDisplayGrid,
            'json-viewer': JsonViewer,
            DataList
        },
        mixins: [
            watchAll,
            validator,
            authentication
        ],
        data: () => {
            return {
                claimPolicyDetailsInputs1: [
                    {
                        id: 'number',
                        label: 'Policy number',
                        type: 'text',
                        placeholder: 'Policy number',
                        dataPath: 'number',
                        copy: true
                    },
                    {
                        id: 'lastUpdated',
                        label: 'Date updated (Claim sys)',
                        type: 'text',
                        placeholder: 'Date updated (Claim sys)',
                        dataPath: 'lastUpdatedFormated'
                    },
                    {
                        id: 'dateCreated',
                        label: 'Date created (Claim sys)',
                        type: 'text',
                        placeholder: 'Date created (Claim sys)',
                        dataPath: 'dateCreatedFormated'
                    },
                    {
                        id: 'policyScheduleLink',
                        label: 'Policy Schedule',
                        type: 'anchor',
                        target: '_blank',
                        link_text: 'Click to open in new tab.',
                        placeholder: '',
                        dataPath: 'policyDocumentVersionLink'
                    },
                    {
                        id: 'sal',
                        label: 'Single article limit',
                        type: 'text',
                        placeholder: 'Single article limit',
                        dataPath: 'sal',
                        customFormatter: formatNumber(2)
                    },
                    {
                        id: 'coverLimit',
                        label: 'Cover limit',
                        type: 'text',
                        placeholder: 'Coverlimit',
                        dataPath: 'coverLimit',
                        customFormatter: formatNumber(2)
                    },
                    {
                        id: 'addonSaleId',
                        label: 'Addon sale id',
                        type: 'text',
                        placeholder: 'Addon sale id',
                        dataPath: 'addonSaleId',
                        copy: true
                    },
                    {
                        id: 'versionDateFormated',
                        label: 'Version date',
                        type: 'text',
                        placeholder: 'Version date',
                        dataPath: 'versionDateFormated'
                    },
                    {
                        id: 'purchaseDateFormated',
                        label: 'Purchase date',
                        type: 'text',
                        placeholder: 'Purchase date',
                        dataPath: 'purchaseDateFormated'
                    }
                ],
                claimPolicyDetailsInputs2: [
                    {
                        id: 'title',
                        label: 'Title',
                        type: 'text',
                        placeholder: 'Title',
                        dataPath: 'title'
                    },
                    {
                        id: 'firstname',
                        label: 'First name',
                        type: 'text',
                        placeholder: 'First name',
                        dataPath: 'firstname'
                    },
                    {
                        id: 'lastname',
                        label: 'Last name',
                        type: 'text',
                        placeholder: 'Last name',
                        dataPath: 'lastname'
                    },
                    {
                        id: 'dateOfBirth',
                        label: 'Date of birth',
                        type: 'text',
                        placeholder: 'Date of birth',
                        dataPath: 'dateOfBirth'
                    },
                    {
                        id: 'telephoneNumber',
                        label: 'Telephone number',
                        type: 'text',
                        placeholder: 'Telephone number',
                        dataPath: 'telephoneNumber'
                    },
                    {
                        id: 'mobileNumber',
                        label: 'Mobile number',
                        type: 'text',
                        placeholder: 'Mobile number',
                        dataPath: 'mobileNumber'
                    },
                    {
                        id: 'emailAddress',
                        label: 'Email address',
                        type: 'text',
                        placeholder: 'Email address',
                        dataPath: 'emailAddress'
                    },
                    {
                        id: 'addressLine1',
                        label: 'Address',
                        type: 'text',
                        placeholder: 'Address line 1',
                        dataPath: 'address.line1'
                    },
                    {
                        id: 'addressLine2',
                        label: '',
                        type: 'text',
                        placeholder: 'Address line 2',
                        dataPath: 'address.line2'
                    },
                    {
                        id: 'addressCity',
                        label: 'City',
                        type: 'text',
                        placeholder: 'Address City',
                        dataPath: 'address.city'
                    },
                    {
                        id: 'addressCounty',
                        label: 'County',
                        type: 'text',
                        placeholder: 'Address County',
                        dataPath: 'address.county'
                    },
                    {
                        id: 'addressPostcode',
                        label: 'Postcode',
                        type: 'text',
                        placeholder: 'Address Postcode',
                        dataPath: 'address.postcode'
                    },
                    {
                        id: 'addressCountry',
                        label: 'Country',
                        type: 'text',
                        placeholder: 'Address Country',
                        dataPath: 'address.country'
                    }
                ],
                claimPolicyDetailsInputs3: [
                    {
                        id: 'id',
                        label: 'Id',
                        type: 'text',
                        placeholder: 'Id',
                        dataPath: 'id'
                    },
                    {
                        id: 'deviceTypeId',
                        label: 'Device type id',
                        type: 'text',
                        placeholder: 'Device type',
                        dataPath: 'deviceTypeId'
                    },
                    {
                        id: 'deviceMakeId',
                        label: 'Device make id',
                        type: 'text',
                        placeholder: 'Device make',
                        dataPath: 'deviceMakeId'
                    },
                    {
                        id: 'make',
                        label: 'Make',
                        type: 'text',
                        placeholder: 'Make',
                        dataPath: 'make'
                    },
                    {
                        id: 'deviceModelId',
                        label: 'Device model id',
                        type: 'text',
                        placeholder: 'Device model',
                        dataPath: 'deviceModelId'
                    },
                    {
                        id: 'model',
                        label: 'Model',
                        type: 'text',
                        placeholder: 'Model',
                        dataPath: 'model'
                    },
                    {
                        id: 'value',
                        label: 'Value',
                        type: 'text',
                        placeholder: 'Value',
                        dataPath: 'value'
                    },
                    {
                        id: 'imeiNo',
                        label: 'IMEI no',
                        type: 'text',
                        placeholder: 'IMEI',
                        dataPath: 'imeiNo'
                    },
                    {
                        id: 'serialNo',
                        label: 'Serial no',
                        type: 'text',
                        placeholder: 'Serial',
                        dataPath: 'serialNo'
                    },
                    {
                        id: 'itemGUID',
                        label: 'Item Guid',
                        type: 'text',
                        placeholder: 'GUID',
                        dataPath: 'itemGuid'
                    },
                    {
                        id: 'purchaseDate',
                        label: 'Purchase date',
                        type: 'text',
                        placeholder: 'Purchase date',
                        dataPath: 'purchaseDate'
                    },
                    {
                        id: 'coverStartDate',
                        label: 'Cover start date',
                        type: 'text',
                        placeholder: 'Cover start date',
                        dataPath: 'coverStartDate'
                    },
                    {
                        id: 'coverEndDate',
                        label: 'Cover end date',
                        type: 'text',
                        placeholder: 'Cover end date',
                        dataPath: 'coverEndDate'
                    }
                ],

                claimPolicyDetailsInputs4: [
                    {
                        id: 'title',
                        label: 'Title',
                        type: 'text',
                        placeholder: 'Title',
                        dataPath: 'title'
                    },
                    {
                        id: 'firstname',
                        label: 'First name',
                        type: 'text',
                        placeholder: 'First name',
                        dataPath: 'firstName'
                    },
                    {
                        id: 'lastname',
                        label: 'Last name',
                        type: 'text',
                        placeholder: 'Last name',
                        dataPath: 'lastName'
                    },
                    {
                        id: 'dateOfBirth',
                        label: 'Date of birth',
                        type: 'text',
                        placeholder: 'Date of birth',
                        dataPath: 'dateOfBirth'
                    }
                ],

                claimPolicyDetailsInputs5: [
                    {
                        id: 'excess',
                        label: 'Excess (£)',
                        type: 'text',
                        placeholder: 'Excess',
                        dataPath: 'excess'
                    },
                    {
                        id: 'isExcessWaived',
                        label: 'Is Excess Waived',
                        type: 'text',
                        placeholder: 'Is Excess Waived',
                        dataPath: 'isExcessWaived',
                        customFormatter: trueFalseToYesNo
                    }
                ],

                claimPolicyDetailsInputs6: [
                    {
                        id: 'travelCoverStartDate',
                        label: 'Cover Start Date',
                        type: 'text',
                        placeholder: 'Cover Start Date',
                        dataPath: 'travelCoverStartDate'
                    },
                    {
                        id: 'travelCoverEndDate',
                        label: 'Cover End Date',
                        type: 'text',
                        placeholder: 'Cover End Date',
                        dataPath: 'travelCoverEndDate'
                    }
                ],

                claimPolicyDetailsInputs7: [
                    {
                        id: 'number',
                        label: 'Policy Number',
                        type: 'text',
                        placeholder: 'Policy Number',
                        dataPath: 'number',
                        copy: true
                    },
                    {
                        id: 'product',
                        label: 'Product',
                        type: 'text',
                        placeholder: 'Product',
                        dataPath: 'productName'
                    },
                    {
                        id: 'underwriter',
                        label: 'Underwriter',
                        type: 'text',
                        placeholder: 'Underwriter',
                        dataPath: 'underwriterDescription'
                    },
                    {
                        id: 'policySchedule',
                        label: 'Policy Schedule',
                        type: 'text',
                        placeholder: 'Policy Schedule',
                        dataPath: 'policyDocumentVersion'
                    },
                    {
                        id: 'sal',
                        label: 'Single article limit',
                        type: 'text',
                        placeholder: 'Single article limit',
                        dataPath: 'sal',
                        customFormatter: formatNumber(2)
                    },
                    {
                        id: 'coverLimit',
                        label: 'Cover limit',
                        type: 'text',
                        placeholder: 'Coverlimit',
                        dataPath: 'coverLimit',
                        customFormatter: formatNumber(2)
                    },
                    {
                        id: 'addonSaleId',
                        label: 'Addon sale id',
                        type: 'text',
                        placeholder: 'Addon sale id',
                        dataPath: 'addonSaleId',
                        copy: true
                    }
                ],

                attemptImport: false,
                importPolicyCriteria: Object.assign({}, importPolicyCriteriaInit),

                tigaPolicyData: [],
                tigaPolicyCols: [
                    {
                        key: 'number',
                        display: 'Number'
                    },
                    {
                        key: 'addonSaleId',
                        display: 'Addon sale id'
                    },
                    {
                        key: 'isMandatory',
                        display: 'Mandatory'
                    },
                    {
                        key: 'sal',
                        display: 'SAL'
                    },
                    {
                        key: 'coverLimit',
                        display: 'Cover limit'
                    },
                    {
                        key: 'travelCoverStartDate',
                        display: 'Cover start date'
                    },
                    {
                        key: 'travelCoverEndDate',
                        display: 'Cover end date'
                    },
                    {
                        key: 'purchaseDate',
                        display: 'Purchase date'
                    },
                    {
                        key: 'versionDate',
                        display: 'Version date'
                    }
                ],
                selectedTigaPolicy: null

            }
        },
        computed: {
            selectedClaim() {
                return this.$store.getters.selectedClaim
            },
            policyDetails() {
                return this.selectedClaim.policyDetails
            },
            deserialisedObject() {
                if (this.policyDetails) {
                    if (this.federation) {
                        return {
                            ...this.policyDetails.deserialisedObject, federation: this.federation
                        }
                    }
                    return this.policyDetails.deserialisedObject
                }
            },
            policyNumberInValid() {
                //console.log(this.getValidatorIsValid(this.importPolicyCriteria, 'policyNumber'))
                //console.log(this.attemptImport)
                return !this.getValidatorIsValid(this.importPolicyCriteria, 'policyNumber') && this.attemptImport
            },
            policyNumberInValidFeedback() {
                return this.importPolicyCriteria.validators.find(v => v.item == 'policyNumber').inValidFeedback
            },
            resellerId() { return this.selectedClaim.resellerId },
            resellerName() { return this.selectedClaim.resellerName },
            claimantEmailAddress() { return this.selectedClaim.claimantDetails.email },
            userHasAccess() {
                return this.$adminUser.hasRole(userRoles.RESET_POLICY)
            },
            isTigaPolicy() {
                try {
                    return this.selectedClaim.insuranceLineId == 2
                } catch (err) {
                    return false
                }
            },
            isPolFedPolicy() {
                try {
                    return this.selectedClaim.insuranceLineId == 5
                } catch (err) {
                    return false
                }
            },
            isTgaPolicy() {
                console.log('isTgaPolicy this.selectedClaim.insuranceLineId: ', this.selectedClaim.insuranceLineId)
                try {
                    return this.selectedClaim.insuranceLineId == 3
                } catch (err) {
                    return false
                }
            },
            /* Get this from db soon!! */
            federations() {
                return [{ id: 1, label: 'Avon and Somerset Police Federation' },
                { id: 5, label: 'City of London Police Federation' },
                { id: 6, label: 'Cleveland Police Federation' },
                { id: 9, label: 'Devon and Cornwall Police Federation' },
                { id: 11, label: 'Durham Police Federation' },
                { id: 13, label: 'Essex Police Federation' },
                { id: 17, label: 'Hampshire Police Federation' },
                { id: 18, label: 'Hertfordshire Police Federation' },
                { id: 20, label: 'Kent Police Federation' },
                { id: 25, label: 'Metropolitan Police Federation' },
                { id: 27, label: 'Norfolk Police Federation' },
                { id: 34, label: 'Staffordshire Police Federation' },
                { id: 35, label: 'Suffolk Police Federation' },
                { id: 37, label: 'Sussex Police Federation' },
                { id: 41, label: 'West Midlands Police Federation' },
                { id: 44, label: 'British Transport Police Federation' },
                { id: 45, label: 'George Burrows GIS Staff Scheme' }]
            },
            federation() {
                try {
                    if (this.deserialisedObject && this.federations) {
                        if (this.deserialisedObject.federationId) {
                            let fed = this.federations.find(f => f.id == this.deserialisedObject.federationId)
                            return fed.label
                        }
                    }
                    return null
                } catch {
                    return null
                }
            },
            claimPolicyDetailsInputs8() {
                return [
                    ...this.claimPolicyDetailsInputs7,
                    {
                        id: 'federationId',
                        label: 'Federation Id',
                        type: 'text',
                        placeholder: 'Federation Id',
                        dataPath: 'federationId'
                    },
                    {
                        id: 'federation',
                        label: 'Federation',
                        type: 'text',
                        placeholder: 'Federation',
                        dataPath: 'federation'
                    }
                ]
            },
            hasPolicyholder() {
                if (this.deserialisedObject) {
                    return this.deserialisedObject.hasOwnProperty('policyholder')
                }
                return false
            }
        },
        mounted() {
            this.watchAll(['importPolicyCriteria.policyNumber'], this.importPolicyCriteriaRunValidators.bind(this));

            this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                console.log('Modal is about to be shown', bvEvent, modalId)
                if (modalId == this._uid + 'import-policy-modal') {
                    this.tigaPolicyData = []
                    this.selectedTigaPolicy = null
                }
            })
        },
        methods: {
            ...mapActions({
                importPolicyClaim: 'importPolicyClaim2',
                checkUserExists: 'formUser/checkUserExists',
                searchTigaQuote: 'searchTigaQuote',
                resetPolicyTigaQuote: 'resetPolicyTigaQuote'
            }),
            showModal() {
                //console.log('this.policyDetails: ', this.policyDetails)
                this.importPolicyCriteria.policyNumber = this.policyDetails.number
                this.$bvModal.show(this._uid + 'import-policy-modal')
            },
            async handleSearchPolicyClick() {
                this.attemptImport = true
                if (getValidatorsIsValid(this.importPolicyCriteria)) {
                    let { insuranceLineId, claimId, policyId } = this.selectedClaim
                    let { policyNumber } = this.importPolicyCriteria

                    let quotes = await this.searchTigaQuote(policyNumber)
                    console.log(quotes)
                    this.tigaPolicyData = quotes.data

                    //this.importPolicyClaim({ insuranceLineId, claimId, policyId, policyNumber })
                    //this.$bvModal.hide(this._uid + 'import-policy-modal')
                    //this.importPolicyCriteriaReset()
                    //this.attemptImport = false

                    //let { resellerId, claimantEmailAddress } = this
                    //this.checkUserExists({ resellerId, emailAddress: claimantEmailAddress })


                }
            },
            async handleImportPolicyClick() {
                console.log('-this.selectedTigaPolicy:', this.selectedTigaPolicy)
                this.attemptImport = true
                //if (getValidatorsIsValid(this.importPolicyCriteria)) {
                    let { insuranceLineId, claimId, policyId } = this.selectedClaim
                    let { policyNumber } = this.importPolicyCriteria
                    let { quoteId } = this.selectedTigaPolicy

                console.log('-importPolicyClaim payload: ', { insuranceLineId, claimId, policyId, policyNumber, quoteId })
                    this.importPolicyClaim({ insuranceLineId, claimId, policyId, policyNumber, quoteId })
                    this.$bvModal.hide(this._uid + 'import-policy-modal')
                    this.importPolicyCriteriaReset()
                    this.attemptImport = false

                console.log('-this:', this)
                let { resellerId, claimantEmailAddress } = this

                console.log('-checkUserExists: ', { resellerId, emailAddress: claimantEmailAddress })
                    this.checkUserExists({ resellerId, emailAddress: claimantEmailAddress })


                //}
            },
            handleCancelClick() {
                this.$bvModal.hide(this._uid + 'import-policy-modal')
            },
            importPolicyCriteriaRunValidators() { runValidators(this.importPolicyCriteria) },
            importPolicyCriteriaReset() { this.importPolicyCriteria = Object.assign({}, importPolicyCriteriaInit) },
            async handleResetPolicyClick() {
                console.log(this.policyDetails)
                this.$bvModal.msgBoxConfirm('Please confirm that you want to reset the policy?')
                    .then(value => {
                        console.log(value)
                        if (value == true) {
                            this.resetPolicyTigaQuote(this.policyDetails.id).then(response => {
                                console.log(response)
                            })
                        }
                    })
                    .catch(err => {
                        // An error occurred
                    })
            },
            handleSelectedItemsChange(ev) {
                console.log(ev)
                this.selectedTigaPolicy = ev[0]
            }
        }
    }
</script>